export const STATUS_TABS = ['Draft' , 'Invited', 'In Progress',  'Complete'] as const
export type __StatusTabs__ = typeof STATUS_TABS[number]

declare global {
    type StatusTabs = __StatusTabs__
}